<template>
  <div class="info-container">
    <div class="content">
      <!-- <template v-if="itemList.length > 0 || scrollFlag"> -->
      <template>
        <Item
          v-for="v in itemList"
          :key="v.id"
          :every="v"
          :curcer="v.id"
          @itemClick="goDetail"
        >
        </Item>
        <Scroll :scrollFlag="scrollFlag" :isEnd="isEnd"/>
      </template>
      <!-- <NoData v-if="itemList.length == 0 && !scrollFlag"></NoData> -->
    </div>
  </div>
</template>

<script>
import Item from "@/components/pager/Item";
import Scroll from "@/components/paging/scroll";
// import NoData from "@/views/PCView/search/components/NoData.vue";
export default {
  components: {
    Item,
    Scroll,
    // NoData
  },
  created() {
    // 论文列表
    this.getMeetingList(this.params);
  },
  data() {
    return {
      scrollFlag: false,
      isEnd: false,
      total: 0,
      itemList: [],
      params: {
        userType: 1,
        companyId: this.$route.query.id,
        pageNo: '1',
        pageSize: '5'
      },
    };
  },
  methods: {
    async getMeetingList(obj) {
      this.scrollFlag = true;
      this.isEnd = false;
      const resp = await this.$apis.hundredServe.getMeetingList(obj);
      this.total = +resp.data.total;
      this.itemList.push(...resp.data.list);
      this.scrollFlag = false;
      this.isEnd = obj.pageNo >= this.total / 5;
    },
    goDetail(e) {
      let routeUrl = this.$router.resolve({
        path: "meetingDetails",
        query: {
          id: e.id,
          type: 8
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
}
</script>

<style>

</style>